import { bool, objectOf } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import DesignWisePerformance from '@features/crm/v3/dashboard/components/DesignWisePerformance';
import PerformanceChart from '@features/crm/v3/dashboard/components/PerformanceChart';

import {
	compareCRMBrandWisePerformance,
	compareCRMRegionWisePerformance,
	compareCRMTeamWisePerformance,
	getCRMBrandWisePerformance,
	getCRMRegionWisePerformance,
	getCRMTeamWisePerformance
} from '@services/crmService';

import { isAdmin, isCRMManagement } from '@utils/Util';

const RegionalAdndDesignWisePerformance = ({ summary, isIndividualUser }) => {
	const filterFields = useSelector((store) => store.filterFieldStore);

	const getSelectedFilters = () => {
		return {
			isCountryExist: filterFields?.countryId?.[0]?.key,
			isBrandExist: filterFields?.brandId?.[0]?.key,
			isAccountManagerExist: filterFields?.accountManagerId?.[0]?.key
		};
	};

	const getDataFetcher = () => {
		if (!getSelectedFilters()?.isBrandExist && getSelectedFilters()?.isAccountManagerExist) {
			return {
				compare: compareCRMBrandWisePerformance,
				get: getCRMBrandWisePerformance
			};
		} else if (
			getSelectedFilters()?.isCountryExist ||
			getSelectedFilters()?.isBrandExist ||
			!isCRMManagement()
		) {
			return {
				compare: compareCRMTeamWisePerformance,
				get: getCRMTeamWisePerformance
			};
		} else {
			return {
				compare: compareCRMRegionWisePerformance,
				get: getCRMRegionWisePerformance
			};
		}
	};

	const renderChartTitle = () => {
		if (getSelectedFilters()?.isBrandExist && getSelectedFilters()?.isAccountManagerExist) {
			return 'Account Manager’s Performance';
		} else if (!getSelectedFilters()?.isBrandExist && getSelectedFilters()?.isAccountManagerExist) {
			return 'Brand Wise Performance';
		} else if (
			getSelectedFilters()?.isCountryExist ||
			getSelectedFilters()?.isBrandExist ||
			!isCRMManagement()
		) {
			return isIndividualUser && !isAdmin() ? 'Your Performance' : 'Team Performance';
		} else {
			return 'Regional Performance';
		}
	};

	const renderChartVarName = () => {
		if (!getSelectedFilters()?.isBrandExist && getSelectedFilters()?.isAccountManagerExist) {
			return 'brand';
		} else if (
			getSelectedFilters()?.isCountryExist ||
			getSelectedFilters()?.isBrandExist ||
			!isCRMManagement()
		) {
			return 'teamMember';
		} else {
			return 'country';
		}
	};

	return (
		<div className="regional-performance-container">
			<div className="left-half scroll-x-label">
				<PerformanceChart
					dataFetcher={getDataFetcher()}
					title={renderChartTitle()}
					varName={renderChartVarName()}
					numberOfBars={5}
				/>
			</div>
			<div className="right-half w-100">
				<DesignWisePerformance summary={summary} />
			</div>
		</div>
	);
};

RegionalAdndDesignWisePerformance.propTypes = {
	summary: objectOf.isRequired,
	isIndividualUser: bool.isRequired
};

export default RegionalAdndDesignWisePerformance;
